import React from 'react';

export default function OnlineOfflineTabs({ active, onChange, t }) {
  return (
    <div className="orders-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={active === 'online'}
        className={'orders-tabs__btn' + (active === 'online' ? ' orders-tabs__btn--active' : '')}
        onClick={() => onChange('online')}
      >
        {t('ordersLayout.tabOnline')}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'offline'}
        className={'orders-tabs__btn' + (active === 'offline' ? ' orders-tabs__btn--active' : '')}
        onClick={() => onChange('offline')}
      >
        {t('ordersLayout.tabOffline')}
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OnlineOfflineTabs.jsx